import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Content } from './styles';

export const TOOLTIP_VARIANTS = ['success', 'error'];
export const TOOLTIP_PLACEMENTS = ['top', 'bottom'];

export class Tooltip extends Component {
	static propTypes = {
		text: PropTypes.node.isRequired,
		show: PropTypes.bool,
		placement: PropTypes.oneOf(TOOLTIP_PLACEMENTS),
		spacing: PropTypes.number,
		variant: PropTypes.oneOf(TOOLTIP_VARIANTS),
		onHide: PropTypes.func,
	};

	static defaultProps = {
		duration: 2500,
		placement: TOOLTIP_PLACEMENTS[0],
		spacing: 0,
		variant: TOOLTIP_VARIANTS[0],
	};

	state = { isOpen: this.props.show };
	timeout = undefined;

	componentWillMount() {
		if (this.props.show) {
			this.show();
		}
	}

	componentWillUnmount() {
		if (this.timeout) window.clearTimeout(this.timeout);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.show !== this.props.show) {
			if (nextProps.show) {
				this.show();
			} else {
				this.hide();
			}
		}
	}

	render() {
		const {
			children,
			placement,
			spacing,
			text,
			variant,
			...props
		} = this.props;
		const { isOpen } = this.state;

		return (
			<Wrapper {...props}>
				{children}
				{isOpen && (
					<Content
						placement={placement}
						spacing={spacing}
						variant={variant}
						onClick={this.hide}
					>
						{text}
					</Content>
				)}
			</Wrapper>
		);
	}

	show() {
		const { duration } = this.props;
		this.setState({ isOpen: true });
		if (this.timeout) window.clearTimeout(this.timeout);
		this.timeout = window.setTimeout(this.hide, duration);
	}

	hide = () => {
		const { onHide } = this.props;
		this.setState({ isOpen: false }, () => onHide && onHide());
		if (this.timeout) window.clearTimeout(this.timeout);
	};
}
